import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Remove } from "../../../entities";
export const FETCH_DELETE_ENTITIES_REQUEST = "FETCH_DELETE_ENTITIES_REQUEST";
export const FETCH_DELETE_ENTITIES_SUCCESS = "FETCH_DELETE_ENTITIES_SUCCESS";
export const FETCH_DELETE_ENTITIES_FAILURE = "FETCH_DELETE_ENTITIES_FAILURE";

interface ActionPagination<T> {
  type: string;
  payload: T;
}

const fetchDeleteEntitiesRequest = () => {
  return {
    type: FETCH_DELETE_ENTITIES_REQUEST,
  };
};

const fetchDeleteEntitiesSuccess = (
  data: any
): ActionPagination<Result<any>> => {
  return {
    type: FETCH_DELETE_ENTITIES_SUCCESS,
    payload: data,
  };
};

const fetchDeleteEntitiesFailure = (error: any) => {
  return {
    type: FETCH_DELETE_ENTITIES_FAILURE,
    payload: error,
  };
};

export const remove = (id: string) => {
  return async (dispatch: Dispatch<AnyAction>) => {
    dispatch(fetchDeleteEntitiesRequest());
    try {
      await Remove(id);
      dispatch(fetchDeleteEntitiesSuccess(true));
    } catch (error: any) {
      dispatch(fetchDeleteEntitiesFailure(error.message));
    }
  };
};
